import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { ScrollPanel } from "primereact/scrollpanel";
import "../../../assets/css/ScrollPanelDemo.css";
import "../../../assets/css/DataTableDemo.css";
import "../../../assets/css/DialogDemo.css";
import ConsultaServicio from "../servicios/ConsultaServicio";
import NotasServicio from "../servicios/NotasServicio";
import { RadioButton } from "primereact/radiobutton";
import { alignment, defaultDataType } from "export-xlsx";
import ExcelExport from "export-xlsx";
import { jsPDF } from "jspdf";
import { ProgressBar } from "primereact/progressbar";
import hcOffcanvasNav from "hc-offcanvas-nav";
import { saveAs } from "file-saver";
import { ToggleButton } from "primereact/togglebutton";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../Barra";

export default function ListadosLiquidacionMedicos(props) {
  //const classes = useStyles();
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID", dataKey: "ID" },
    { title: "Base", dataKey: "Base" },
    { title: "Móvil", dataKey: "Movil" },
    { title: "Ing. Méd.", dataKey: "FechaIngresoMedico" },
    { title: "Sal. Méd", dataKey: "FechaSalidaMedico" },
    { title: "Servicios", dataKey: "CantidadServicios" },
    { title: "Pediatricos", dataKey: "Pediatricos" },
    { title: "Coseguros", dataKey: "Coseguros" },
    { title: "V. Guardia", dataKey: "ValorGuardia" },
    { title: "Adic. Nocturno", dataKey: "AdicionalNocturno" },
    { title: "Adic. Pediátrico", dataKey: "AdicionalPediatrico" },
    { title: "Adic. Sa.Do.Fe", dataKey: "AdicionalSadofe" },
  ];

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [fechas, setFechas] = useState(null);
  const [visible, setVisible] = useState(false);
  const [visibleUpload, setVisibleUpload] = useState(false);
  const toast = useRef(null);
  const [radio, setRadio] = useState("tomado");
  const [tripulanteSeleccionado, setTripulanteSeleccionado] = useState(null);
  const [checked1, setChecked1] = useState(false);
  const [tope, setTope] = useState(14);
  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    statusAcceso2,
    colores,
    moviles,
    medicos,
    configuracion,
    choferes,
    enfermeros,
    obtenerAcceso,
    obtenerMedicos,
    obtenerChoferes,
    obtenerEnfermeros,
  } = configuracionContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    serviciosFinalizados,
    serviciosFinalizadosExcel,
    obtenerLiquidacionesMedicas,
  } = serviciosContext;

  useEffect(() => {
    if (configuracion && configuracion.destinatario !== 2) {
      exitClick();
    }

    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Listados" });
    }
    obtenerMedicos({ todos: false });
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const exitClick = (e) => {
    onHideFechas();
    navigate(`/`);
    var Nav = new hcOffcanvasNav("#main-nav", {
      disableAt: false,
      customToggle: ".toggle",
      levelSpacing: 40,
      navTitle: "Home",
      levelTitles: true,
      levelTitleAsBack: true,
      pushContent: "#container",
      labelClose: false,
      position: "left",
      levelOpen: "overlap",
    });
    Nav.open(1, 2);
  };

  const startClick = (e) => {
    setTimeout(() => {
      navigate(`/listadosliquidacionmedicos`);
      setVisibleFechas(true);
    }, 2000);
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
    setTripulanteSeleccionado(null);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (
      !fechas ||
      fechas.desde === undefined ||
      fechas.desde === null ||
      fechas.desde.trim() === ""
    ) {
      mensajeAlerta(
        "Listado de Liquidación de Médicos",
        "Fecha desde es necesaria !.",
        "error"
      );
      return;
    }

    if (
      !fechas ||
      fechas.hasta === undefined ||
      fechas.hasta === null ||
      fechas.hasta.trim() === ""
    ) {
      mensajeAlerta(
        "Listado de Liquidación de Médicos",
        "Fecha hasta es necesaria !.",
        "error"
      );
      return;
    }

    if (tripulanteSeleccionado === null) {
      mensajeAlerta(
        "Listado de Liquidación de Médicos",
        "Tripulante es necesario !.",
        "error"
      );
      return;
    }

    let fdesde = fechas.desde; //+ "T00:00:00";
    let fhasta = fechas.hasta; //+ "T23:59:59";

    var elem;

    await obtenerLiquidacionesMedicas({
      fdesde: fdesde,
      fhasta: fhasta,
      tripulanteSeleccionado,
      tope,
      edadPediatrico: configuracion.edadPediatrico,
      nocturnoDesde: configuracion.nocturnoDesde,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    onHideFechas();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const exportExcel = () => {
    if (serviciosFinalizadosExcel && serviciosFinalizadosExcel.length > 0) {

      for (let i = 0; i < serviciosFinalizadosExcel.length; i++) {
        serviciosFinalizadosExcel[i].Coseguros = parseFloat(serviciosFinalizadosExcel[i].Coseguros, 10);
        serviciosFinalizadosExcel[i].ValorGuardia = parseFloat(serviciosFinalizadosExcel[i].ValorGuardia, 10);
        serviciosFinalizadosExcel[i].Presentismo = parseFloat(serviciosFinalizadosExcel[i].Presentismo, 10);
        serviciosFinalizadosExcel[i].AdicionalPediatrico = parseFloat(serviciosFinalizadosExcel[i].AdicionalPediatrico, 10);
        serviciosFinalizadosExcel[i].AdicionalNocturno = parseFloat(serviciosFinalizadosExcel[i].AdicionalNocturno, 10);
        serviciosFinalizadosExcel[i].AdicionalSadofe = parseFloat(serviciosFinalizadosExcel[i].AdicionalSadofe, 10);
      }

      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(serviciosFinalizadosExcel);
        const workbook = {
          Sheets: { data: worksheet },
          SheetNames: ["data"],
        };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "horariosTripulacion");
      });
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });

    startClick();
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("l");
        doc.setFontSize(12);
        doc.text(
          "Liquidacion de " +
            tripulanteSeleccionado.nombre +
            " desde " +
            formatDate(fechas.desde) +
            " hasta " +
            formatDate(fechas.hasta),
          50,
          8
        );
        doc.autoTable(exportColumns, serviciosFinalizadosExcel, {
          styles: {
            fontSize: 7,
          },
          columnStyles: {
            5: {
              halign: "right",
            },
            6: {
              halign: "right",
            },
            7: {
              halign: "right",
            },
            8: {
              halign: "right",
            },
            9: {
              halign: "right",
            },
            10: {
              halign: "right",
            },
            11: {
              halign: "right",
            },
          },
        });

        const lastItem =
          serviciosFinalizadosExcel[serviciosFinalizadosExcel.length - 1];

        doc.setFontSize(10);
        let finalY = doc.previousAutoTable.finalY;
        doc.text(
          "Total Liquidación:                   Total Guardias              Presentismo            Adic. Pediátricos       Adic. Nocturnos        Adic. Sa.Do.Fe.                     Total",
          10,
          finalY + 10
        );

        //doc.text(String(lastItem.Coseguros), 60, finalY + 20);

        doc.text(String(lastItem.ValorGuardia), 60, finalY + 20);

        doc.text(
          checked1 ? String(lastItem.Presentismo) : "0.00",
          95,
          finalY + 20
        );

        doc.text(String(lastItem.AdicionalPediatrico), 130, finalY + 20);

        doc.text(String(lastItem.AdicionalNocturno), 165, finalY + 20);

        doc.text(String(lastItem.AdicionalSadofe), 200, finalY + 20);

        if (checked1) {
          doc.text(
            String(
              parseFloat(
                Number(lastItem.ValorGuardia) +
                  Number(lastItem.Presentismo) +
                  Number(lastItem.AdicionalPediatrico) +
                  Number(lastItem.AdicionalNocturno) +
                  Number(lastItem.AdicionalSadofe)
              ).toFixed(2)
            ),
            235,
            finalY + 20
          );
        } else {
          doc.text(
            String(
              parseFloat(
                Number(lastItem.ValorGuardia) +
                  Number(lastItem.AdicionalPediatrico) +
                  Number(lastItem.AdicionalNocturno) +
                  Number(lastItem.AdicionalSadofe)
              ).toFixed(2)
            ),
            235,
            finalY + 20
          );
        }

        window.open(doc.output("bloburl"));
      });
    });
    startClick();
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Liquidación de Médicos"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
            //exportExcel();
          }}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        >
          Excel
        </Button>
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
          }}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        >
          PDF
        </Button>
        {/*
        <ButtonMui
          onClick={aceptarFechas}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        */}
        <ButtonMui
          onClick={exitClick}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(medicos);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {medicos ? (
            <Fragment>
              <Dialog
                header={renderHeaderFechas()}
                visible={visibleFechas}
                closable={false}
                footer={renderFooterFechas()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "70vw", paddingBottom: "0" }}
                position="top"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="desde"
                      label="Desde"
                      type="datetime-local"
                      fullWidth
                      variant="standard"
                      //onKeyDown={handleEnter}
                      value={fechas && fechas.desde ? fechas.desde : null}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setFechas({
                          ...fechas,
                          desde: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="hasta"
                      label="Hasta"
                      type="datetime-local"
                      fullWidth
                      variant="standard"
                      //onKeyDown={handleEnter}
                      value={fechas && fechas.hasta ? fechas.hasta : null}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setFechas({
                          ...fechas,
                          hasta: e.target.value,
                        });
                      }}
                    />
                  </Grid>

                  <Fragment>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      style={{ paddingLeft: 0, marginTop: "0em" }}
                    />

                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        id="nombre"
                        fullWidth
                        options={medicos}
                        noOptionsText={"No hay opciones"}
                        style={{ marginLeft: ".8vw", color: "green" }}
                        //defaultValue={grupo ? agrupar[grupo - 1] : null}
                        disablePortal
                        getOptionLabel={(option) => option.nombre}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={"Seleccione el Médico"}
                            variant="standard"
                          />
                        )}
                        onChange={(event, value) => {
                          if (value) {
                            setTripulanteSeleccionado(value);
                          } else {
                            setTripulanteSeleccionado(null);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <h6>Presentismo</h6>
                    </Grid>
                    <Grid item xs={6} md={2} style={{ marginTop: "0.5vw" }}>
                      <ToggleButton
                        checked={checked1}
                        onChange={(e) => setChecked1(e.value)}
                        onIcon="pi pi-check"
                        offIcon="pi pi-times"
                        onLabel="Si"
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <TextField
                        id="tope"
                        label="Tope Autoliquidación"
                        value={tope ? tope : 0}
                        fullWidth
                        variant="standard"
                        //onKeyDown={handleEnter}
                        required
                        onChange={(e) => {
                          setTope(e.target.value);
                        }}
                      />
                    </Grid>
                  </Fragment>
                </Grid>
              </Dialog>
            </Fragment>
          ) : (
            <Spinner />
          )}
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
